import { defineModule, } from 'direct-vuex';

export interface UserDetails {
	customerNewEmail: string;
	customerPassword: string;
}
export interface ChangeEmailAddress {
	currentStep: number | null;
	userDetails: UserDetails | null;
    customerNumber: string;
	customerEmail: string;
	customerLastName: string;
}

export default defineModule({
	namespaced: true as const,
	state: {
		currentStep: null as (number | null),
		userDetails: null,
		customerNumber: '',
		customerEmail: '',
		customerLastName: '',
	} as ChangeEmailAddress,
	getters: {},
	mutations: {
		setStep(state, step: ChangeEmailAddress['currentStep']) {
			state.currentStep = step;
		},
		updateCustomerDetails(state, userDetails) {
			state.userDetails = { ...userDetails, };
		},
		setCustomerEmail(state, customerEmail) {
			state.customerEmail = customerEmail;
		},
		setCustomerLastNme(state, customerLastName) {
			state.customerLastName = customerLastName;
		},
		setCustomerNumber(state, customerNumber) {
			state.customerNumber = customerNumber;
		},
		reset(state) {
			state.currentStep = null;
			state.userDetails = null;
			state.customerNumber = '';
			state.customerEmail = '';
			state.customerLastName = '';
		},
	},
});
